import { render } from "./Footer.vue?vue&type=template&id=72fb9e43&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=72fb9e43&scoped=true&lang=css"
import "./Footer.vue?vue&type=style&index=1&id=72fb9e43&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72fb9e43"]])

export default __exports__